import Component from "@glimmer/component";
import { service } from "@ember/service";
import DHeadlessTooltip from "float-kit/components/d-headless-tooltip";
import { precompileTemplate } from "@ember/template-compilation";
import { setComponentTemplate } from "@ember/component";
export default class DTooltips extends Component {
  static {
    dt7948.g(this.prototype, "tooltip", [service]);
  }
  #tooltip = (dt7948.i(this, "tooltip"), void 0);
  static {
    setComponentTemplate(precompileTemplate("\n    <div id=\"d-tooltip-portals\"></div>\n\n    {{#each this.tooltip.registeredTooltips key=\"id\" as |tooltip|}}\n      {{#if tooltip.detachedTrigger}}\n        <DHeadlessTooltip @tooltip={{tooltip}} />\n      {{/if}}\n    {{/each}}\n  ", {
      strictMode: true,
      scope: () => ({
        DHeadlessTooltip
      })
    }), this);
  }
}